import React, { PropsWithChildren } from "react";

import { twMerge } from "@/design-system/twMerge";

/** Compact dismiss control inside `Tag` `endContent` (shared by chip-style call sites). */
export const chipDismissButtonClassName =
  "text-textHighEmphasis inline-flex cursor-pointer items-center rounded p-0.5 not-disabled:hover:bg-black/5";

type TagProps = PropsWithChildren<
  React.HTMLAttributes<HTMLSpanElement> & {
    endContent?: React.ReactNode;
  }
>;

export function Tag({ className, children, endContent, ...props }: TagProps) {
  return (
    <span
      className={twMerge(
        "text-label-sm text-textHighEmphasis bg-surface-muted inline-flex items-center gap-2 rounded-lg px-2 py-1",
        className,
      )}
      {...props}
    >
      <span>{children}</span>
      {endContent}
    </span>
  );
}
